// extracted by mini-css-extract-plugin
module.exports = {"grid":"SectionMentors-module--grid--2qVDs","triangle":"SectionMentors-module--triangle--22c3q"};